import React from "react";
import RevolutionizeImg from "../../../images/location_new/fold7/uk.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose Us for Flutter Application Development in UK?</h2>
            <p>
              TekRevol stands out as a premier choice due to its dedicated and
              skilled team of Flutter App developers who possess a deep
              understanding of the framework's capabilities. Our track record of
              successfully completing Flutter projects guarantees the
              development of excellent cross-platform apps with impeccable user
              experiences. Our client-centric approach entails an extensive
              knowledge of business needs, guaranteeing that every Flutter
              application aligns with the client's goals. As a top-ranked
              Flutter app development company, we promise the timely delivery of
              your project, making sure that your project becomes a reality
              within the set timeframe. Our dedication to meeting deadlines and
              keeping open lines of communication ensures that you are kept
              informed at all stages of the project. You may rely on us for your
              Flutter app development.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="app-development-company-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
